import React, { Component } from 'react';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import Notes from 'midi/Notes.js';
import Dropdown from 'react-dropdown'

class FMModulatorOscillatorComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    getSelectedOscillatorType() {
        return this.props.oscillator.oscillatorType;
    }

    onSelectOscillatorType(o) {
        let value = o.value === 'none' ? undefined : o.value;
        this.props.oscillator.oscillatorType = value;
        this.setState(this.state);
    }


    render() {
        let oscillator = this.props.oscillator;
        return (
            <div className="oscillator-component">
              <div className="osc-type-dropdown-container">
                <Dropdown
                  className='osc-type-dropdown'
                  controlClassName='osc-type-control-dropdown'
                  arrowClassName='osc-type-arrow-dropdown'
                  options={OSCILLATOR_OPTIONS}
                  onChange={(o) => this.onSelectOscillatorType(o)}
                  value={getOscillatorOption(this.getSelectedOscillatorType())}
                  placeholder="Osc. Type" />
              </div>
              <div className="clear-fix"/>
              <EffectParameterSlider
                  automation={this.props.automation}
                  name={'Partial Count'}
                  parameter={oscillator.partialCountParameter}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={0}
                  max={16}
                  step={1}
                  />
            </div>
        );
    }
}

const OSCILLATOR_OPTIONS = [
    {value: 'square', label:'Square'},
    {value: 'sine', label:'Sine'},
    {value: 'triangle', label:'Triangle'},
    {value: 'sawtooth', label:'Sawtooth'},
    {value: 'pwm', label:'PWM'},
    {value: 'pulse', label:'Pulse'},
    {value: 'fatsquare', label:'Fat Square'},
    {value: 'fatsine', label:'Fat Sine'},
    {value: 'fattriangle', label:'Fat Triangle'},
    {value: 'fatsawtooth', label:'Fat Sawtooth'},
    {value: 'fmsquare', label:'FM Square'},
    {value: 'fmsine', label:'FM Sine'},
    {value: 'fmtriangle', label:'FM Triangle'},
    {value: 'fmsawtooth', label:'FM Sawtooth'},
];

function getOscillatorOption(value) {
    return OSCILLATOR_OPTIONS.filter(
        osc => osc.value === value)[0];
}

export default FMModulatorOscillatorComponent;

